var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"page-container",staticStyle:{"background-color":"#f0f0f0"},attrs:{"fluid":""}},[_c('NextLevelPowerDropsCheckout',{attrs:{"combos":_vm.combos,"variant":_vm.variant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }